import styled from 'styled-components';
import withImage from '../../../../shared/components/utils/hoc/withImage';
import PhotoDefault from '../../../../shared/assets/images/png/photoDefault.png';
import Screen from '../../../../shared/utils/screen';
interface Props {
  height: number;
  width: number;
  src: string;
}

const SliderImage = styled.img<Props>`
  border-radius: ${30 * Screen.widthRatio}px;
  height: ${428 * Screen.widthRatio}px;
  opacity: 0;
  position: absolute;
  width: ${760 * Screen.widthRatio}px;
`;

SliderImage.defaultProps = {
  src: PhotoDefault,
};

export default withImage(SliderImage, true);
